import { css } from 'linaria';
import { breakpoints } from '../../../../../media';

export const benefitsListStyles = css`
	display: grid;
	grid-gap: 24px;
	grid-template-columns: 1fr 1fr 1fr 1fr;
	grid-template-rows: 308px;
	${breakpoints.to.largeDesktop} {
		grid-template-columns: 1fr 1fr;
		grid-template-rows: 160px 160px;
	}
	${breakpoints.only.mobile} {
		grid-template-columns: 1fr;
		grid-template-rows: repeat(auto-fit, minmax(144px, 1fr));
	}
`;
